import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { InvoicePreviewDetailDto } from "../../../core/models/invoice-preview/InvoicePreviewDetailDto";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../core/services/user-management.service";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { FormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightChargesComponent } from "../../orders/components/freight-charges/freight-charges.component";
import { ClientDetailsComponent } from "../../clients/components/client-details/client-details.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { InvoicePreviewClientDepositComponent } from "../client-deposit/client-deposit.component";
import { InputTextModule } from "primeng/inputtext";
import { InvoicePreviewFreightChargesComponent } from "../freight-charges/freight-charges.component";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-order-details",
  templateUrl: "./invoice-preview-order-details.component.html",
  styleUrls: ["./invoice-preview-order-details.component.scss"],
  imports: [
    SelectModule,
    CommonModule,
    HidedynamicsdatePipe,
    FormsModule,
    ModalStackerComponent,
    FreightChargesComponent,
    ClientDetailsComponent,
    OrderSummaryComponent,
    InvoicePreviewClientDepositComponent,
    InputTextModule,
    InvoicePreviewFreightChargesComponent,
  ],
})
export class InvoicePreviewOrderDetailsComponent implements OnInit {
  @Input() invoicePreviewSummary!: InvoicePreviewDetailDto;
  @Output() addScollHiddenClassEvent = new EventEmitter();
  @Output() updateCustomerPONumberEvent = new EventEmitter<string>();
  @Output() updateJobNameEvent = new EventEmitter<string>();
  @Output() updateShippingMethodEvent = new EventEmitter<string>();
  @Input() customerPONumber = "";
  @Input() salesOrderId = "";
  @Input() invoicePreviewNumber = "";
  @Input() jobName = "";
  @Input() shippingMethodCode = "";

  saleOrderId = "";
  clientId = "";
  orderDisplayModal = false;
  clientDisplayModal = false;
  freightChargesDisplayModal = false;
  clientDepositDisplayModal = false;
  shippingProductsList: ShippingMethod[] = [];
  userData!: GetUserDto;
  showNetCommField = false;

  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    private renderer: Renderer2
  ) {}
  ngOnInit(): void {
    this.getUserProfile();
    this.getAllShippingMethod();
  }

  onOrderSelection(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  onClientSelection(clientId: string) {
    if (clientId) {
      this.clientId = clientId;
      this.clientDisplayModal = true;
    }
  }

  updateCustomerPONumber() {
    this.updateCustomerPONumberEvent.emit(this.customerPONumber);
  }

  updateJobName() {
    this.updateJobNameEvent.emit(this.jobName);
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  addScollHiddenClass() {
    this.addScollHiddenClassEvent.emit();
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  redirectToFreightChargesPage() {
    this.freightChargesDisplayModal = true;
  }

  redirectToClientDepositPage() {
    this.clientDepositDisplayModal = true;
  }

  closeModalForClientDeposit() {
    this.clientDepositDisplayModal = false;
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  onShippingMethodChange(event: SelectChangeEvent) {
    this.updateShippingMethodEvent.emit(event.value);
  }

  // onShippingMethodChangeTitle(onShippingMethodChange: any) {
  //   const data = this.shippingProductsList.find(
  //     (x) => x.modeCodeD365 == onShippingMethodChange
  //   );
  //   if (data) {
  //     return data.modeDescriptionD365;
  //   }
  //   return '';
  // }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          if (
            this.userData?.userRoleId === UserRole.Admin ||
            this.userData?.title?.toLowerCase()?.includes("branding consultant")
          ) {
            this.showNetCommField = true;
          } else {
            this.showNetCommField = false;
          }
        }
      },
    });
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }
}
